import { useTranslation } from 'react-i18next'

import { ChatTextIcon } from '@phosphor-icons/react'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'
import MenuCard from '@/metrics/components/MenuCard/MenuCard'
import ReasonsBreakdownTable from '@/metrics/components/ReasonsBreakdownTable/ReasonsBreakdownTable'

import * as Styles from './styles'

const ReasonsBreakdownCard = ({
  reasons,
  loading,
  showExchanges,
  onExport,
  tableFilters,
  onChangeTableFilters,
  onClickReason,
}) => {
  const { t } = useTranslation()

  const handleSort = value => {
    const filterValueWithOrdering = tableFilters.ordering === value ? `-${value}` : value

    onChangeTableFilters({ ...tableFilters, ordering: filterValueWithOrdering })
  }

  return (
    <Card showBorder={false}>
      <CardTitle>
        <Styles.Title>
          <ChatTextIcon size={24} />
          {t('Motivos')}
        </Styles.Title>
        <MenuCard cardName={t('Motivos')} onExport={onExport} />
      </CardTitle>
      {showExchanges && (
        <CardDescription>
          {t('Para cada motivo, qué parte terminó en reembolso y qué parte en cambio.')}
        </CardDescription>
      )}
      <ReasonsBreakdownTable
        nameLabel={t('Motivo')}
        reasons={reasons}
        loading={loading}
        showExchanges={showExchanges}
        onSort={handleSort}
        orderBy={tableFilters.ordering}
        onClickReason={onClickReason}
      />
    </Card>
  )
}

export default ReasonsBreakdownCard
